export const convertSource = value =>{
    if(value === 8){
        return 'autoagendamientoappallianz'
    }
    return '';
}